import { render, staticRenderFns } from "./DashboardFinancial.vue?vue&type=template&id=83a11b64"
import script from "./DashboardFinancial.js?vue&type=script&lang=js&external"
export * from "./DashboardFinancial.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports